import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Link,
  Stack,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const STEAM_PRIVACY_URL = 'https://steamcommunity.com/my/edit/settings';

const setupSteps = [
  'They need to sign in to GamingWithBros with Steam (same as you).',
  'You must be Steam friends on both sides — we only show mutual app friends.',
  'After signing up, they should open Friends Activity and tap Refresh once so their friend list syncs.',
  'On Steam, set Profile → Edit → Privacy Settings: Friend list and Game details to Public or Friends Only (not Private).',
  'Game titles come from Steam\'s last-2-weeks feed. Friends still appear here without recent plays.',
];

export default function FriendActivitySetupNote() {
  return (
    <Accordion
      defaultExpanded={false}
      elevation={0}
      disableGutters
      className="mb-6 overflow-hidden rounded-xl border border-indigo-500/25 bg-slate-900/50 before:hidden"
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon className="text-slate-400" />}
        className="px-4 py-1 sm:px-5"
      >
        <Stack direction="row" spacing={1.5} alignItems="center">
          <InfoOutlinedIcon className="text-indigo-400" fontSize="small" />
          <Typography className="font-semibold text-slate-100">
            Missing a friend or their games?
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails className="border-t border-indigo-500/15 px-4 pb-4 pt-3 sm:px-5">
        <Stack spacing={1.5} className="text-left">
          <Typography variant="body2" className="text-slate-300">
            Share this checklist with friends who should appear here:
          </Typography>
          <Stack component="ul" spacing={1} className="m-0 list-disc pl-5">
            {setupSteps.map((step) => (
              <Typography
                key={step}
                component="li"
                variant="body2"
                className="text-slate-300"
                sx={{ display: 'list-item' }}
              >
                {step}
              </Typography>
            ))}
          </Stack>
          <Typography variant="body2" className="text-slate-400">
            Steam privacy settings:{' '}
            <Link
              href={STEAM_PRIVACY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-indigo-300 hover:text-indigo-200"
            >
              steamcommunity.com/my/edit/settings
            </Link>
          </Typography>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
